<!-- 头部通知入口：铃铛触发器 + 消息列表/详情弹层 -->
<template>
  <div class="header-notification">
    <el-popover
      v-model:visible="popoverVisible"
      placement="bottom-end"
      trigger="click"
      :width="
        viewMode === 'detail'
          ? NOTIFICATION_DETAIL_WIDTH
          : NOTIFICATION_LIST_WIDTH
      "
      popper-class="notification-popover"
      @show="handlePopoverShow"
    >
      <template #reference>
        <div class="bell-trigger" :aria-label="$t('notifications')">
          <el-icon :size="22">
            <Bell />
          </el-icon>
          <span v-if="hasUnread" class="unread-dot" />
        </div>
      </template>

      <div class="notification-panel">
        <NotificationList
          v-if="viewMode === 'list'"
          :list="list"
          :loading="listLoading"
          :error="listError"
          :page-num="pageNum"
          :page-size="NOTIFICATION_PAGE_SIZE"
          :total="total"
          @page-change="handlePageChange"
          @open-detail="openDetail"
          @refresh="handleRefreshList"
        />
        <NotificationDetail
          v-else
          :detail="detail"
          :error="detailError"
          @back="backToList"
        />
      </div>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { Bell } from '@element-plus/icons-vue'
import NotificationList from './NotificationList.vue'
import NotificationDetail from './NotificationDetail.vue'
import {
  NOTIFICATION_DETAIL_WIDTH,
  NOTIFICATION_LIST_WIDTH,
  NOTIFICATION_PAGE_SIZE,
  useNotification
} from './useNotification'

const $t: any = inject('$t')

const {
  popoverVisible,
  hasUnread,
  viewMode,
  list,
  listLoading,
  listError,
  pageNum,
  total,
  detail,
  detailError,
  handlePopoverShow,
  handlePageChange,
  openDetail,
  backToList,
  handleRefreshList
} = useNotification()
</script>

<style lang="scss" scoped>
.header-notification {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.bell-trigger {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;

  .unread-dot {
    position: absolute;
    top: 0;
    right: -2px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ff4d4f;
    border: 1px solid #fff;
  }
}

.notification-panel {
  min-height: 120px;
}
</style>
